import { render, staticRenderFns } from "./MProjectCard.vue?vue&type=template&id=4a584fe3&"
import script from "./MProjectCard.vue?vue&type=script&lang=js&"
export * from "./MProjectCard.vue?vue&type=script&lang=js&"
import style0 from "./MProjectCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports